module.exports = __webpack_public_path__ + "img/red-wax-seal.3429cbb9.png";